import { Policy } from "../models/policy";

export const policyDescriptions = {
  AA: "Personal Auto",
  AB: "Member's Best Auto",
  AP: "Personal Auto",
  BA: "Commercial Auto",
  BO: "Businessowners",
  BT: "Boatowners",
  CA: "Personal Auto",
  CP: "Commercial Package",
  DF: "Dwelling Fire",
  FA: "Farm Auto",
  FP: "Farm Package",
  HB: "Member's Best Home",
  HO: "Home",
  HP: "Home",
  IM: "Inland Marine",
  MH: "Mobilehome",
  PA: "Personal Auto",
  PE: "Personal Excess",
  UMC: "Commercial Excess",
  UMF: "Farm Excess",
  XB: "Member's Best Excess Liability",
};

export const policyShortDescriptions = {
  AA: "Auto",
  AB: "Auto",
  AP: "Auto",
  BA: "Coml Auto",
  BO: "Business",
  BT: "Boat",
  CA: "Auto",
  CP: "Coml Package",
  DF: "Dwelling Fire",
  FA: "Farm Auto",
  FP: "Farm Package",
  HB: "Home",
  HO: "Home",
  HP: "Home",
  IM: "Inland Marine",
  MH: "Home",
  PA: "Auto",
  PE: "Excess",
  UMC: "Coml Excess",
  UMF: "Farm Excess",
  XB: "Excess",
};

export const policyTypeGroups = {
  auto: ["AA", "AB", "AP", "CA", "PA"],
  boat: ["BT"],
  commercialAuto: ["BAP"],
  commercialBusiness: ["BOP"],
  commercialExcess: ["UMC"],
  commercialPackage: ["CPP"],
  dwellingFire: ["DF"],
  excess: ["PE", "XB"],
  farmAuto: ["FAP"],
  farmExcess: ["UMF"],
  farmPackage: ["FPP"],
  home: ["HB", "HO", "HP", "MH"],
  inlandMarine: ["IM"],
  membersBest: ["AB", "HB", "XB"],
};

export const getPolicyDescription = (policyNumber: string): string =>
  policyDescriptions[policyNumber?.substr(0, 3)] ??
  policyDescriptions[policyNumber?.substr(0, 2)] ??
  "";

export const getPolicyShortDescription = (policyNumber: string): string =>
  policyShortDescriptions[policyNumber?.substr(0, 3)] ??
  policyShortDescriptions[policyNumber?.substr(0, 2)] ??
  "";

export const groupPoliciesByPackageNumber = (
  policies: Policy[]
): Policy[][] => {
  const map = new Map<string, Policy[]>();
  policies.forEach((policy) => {
    const key = !!policy.packageNumber
      ? policy.packageNumber
      : policy.policyNumber;
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [policy]);
    } else {
      collection.push(policy);
    }
  });
  return [...map.values()];
};